module.exports = __webpack_public_path__ + "static/images/add-grey.2c909cedce29fd3e8c542688bbefcc66.svg";